export function encodeToBase64(value: string): string {
  return btoa(value);
}

export function decodeFromBase64(value: string): string {
  return atob(value);
}
